module.exports = __webpack_public_path__ + "img/public/SiteIcons/outerStar.svg?29863b4f";